module.exports = __webpack_public_path__ + "img/icon_status_green_small.a5a2d575.svg";